import React from 'react';
import './AMRS.css';
import FMSimage from '../Assets/amr111.jpg'; // First image
import FMSimage2 from '../Assets/amr222.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/Autometic-meter-reading.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/amr4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/amr.2.jpeg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <h1 className="FMS-heading">AUTOMATIC METER READING (AMR) SOLUTION</h1>
                        <p className="FMS-description">
                            The Automatic Meter Reading (AMR) Solution is designed for accurate data collection from electricity meters located at consumer premises or distribution transformers. It ensures periodic transmission of readings to suppliers, enhancing billing accuracy, reducing manual intervention, and improving utility management efficiency.
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage} alt="AMR Solution" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading Between Images */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>

                {/* Second Section: New Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Intelligent AMR Modem:</strong> Connects via RS-232 (RJ11/12) to electronic energy meters for seamless data collection.</li>
                                <li><strong>DLMS Compatibility:</strong> Works with various standard DLMS-compliant meters.</li>
                                <li><strong>Power Reliability:</strong> Supports 3-phase supply with inbuilt battery backup for power outage alerts.</li>
                                <li><strong>Network Flexibility:</strong> Compatible with 2G/3G/4G SIM cards, with 4G fallback to 3G/2G.</li>
                                <li><strong>Online Monitoring:</strong> Tracks vital billing parameters, tamper events, power outages, and quality power management.</li>
                                <li><strong>Surge Protection:</strong> Features an inbuilt 6 kV surge-protected SMPS-based power supply.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: New Image for Key Features */}
                    <div className="FMS-image-container">
                        <img src={FMSimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading for How it Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How it Works</h2>
                </div>

                {/* Third Section: Layout for How it Works */}
                <div className="FMS-content-container">
                    {/* Left side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage3} alt="How It Works" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            The AMR modem connects to electronic energy meters via RS-232, collecting accurate consumption data. Readings are transmitted periodically to suppliers over 2G/3G/4G networks, with fallback support for reliable connectivity. Online monitoring tracks billing parameters, tamper events, and power outages, while energy auditing and accounting provide actionable insights for efficient utility management.
                        </p>
                    </div>
                </div>

                {/* New Section: Why Choose Us */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Our AMR Solution</h2>
                </div>

                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Accurate Data Collection:</strong> Ensures precise meter readings for reliable billing.</li>
                                <li><strong>Tamper Management:</strong> Detects and alerts on tamper events to prevent energy theft.</li>
                                <li><strong>Power Reliability:</strong> Battery backup and surge protection ensure uninterrupted operation.</li>
                                <li><strong>Cost-Effective:</strong> Supports energy auditing and accounting for optimized resource management.</li>
                                <li><strong>Flexible Connectivity:</strong> Works with 2G/3G/4G networks for robust data transmission.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage4} alt="Why Choose AMR" className="FMS-image" />
                    </div>
                </div>

                {/* New Section: Industries Using Our AMR */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries Using Our AMR Solution</h2>
                </div>

                <div className="FMS-content-container reverse-order-last">
                    {/* Left side: Image for Industries */}
                    <div className="FMS-image-container">
                        <img src={FMSimage5} alt="Industries Using AMR" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our AMR Solution is trusted by various industries for accurate energy monitoring and efficient utility management. These sectors rely on our solution for its precision, reliability, and cost-effectiveness:
                            <ul>
                                <li>Utilities & Power Distribution</li>
                                <li>Industrial Facilities</li>
                                <li>Commercial Complexes</li>
                                <li>Residential Communities</li>
                                <li>Smart Cities</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FMS;